import {
  formatDaysAgo,
  formatDisplayDate,
  formatEvaluationAmount,
  type PurchaseRequest,
} from "../../model";
import { ProcurementQueueOpenIndicator } from "../../presentation/shared/ProcurementQueueOpenIndicator";
import { createApprovalRowModel } from "./approval-row-model";
import { ApprovalDossier } from "./ApprovalDossier";
import type {
  useApprovalsWorkspace,
} from "./useApprovalsWorkspace";

export function ApprovalRow({ model, request }: { model: ReturnType<typeof useApprovalsWorkspace>; request: PurchaseRequest ;}) {
  const context = createApprovalRowModel(model, request);
  const {
    initialRequestNo,
    setExpandedRequestId,
    setClosingRequestId,
    closeDecisionComposer,
    evaluation,
    isCompleted,
    displayedOffer,
    selectionLabel,
    attentionLabel,
    attentionDetail,
    requiresAttention,
  } = context;
  return (
    <article
      className={`approval-item${isCompleted ? " is-completed" : ""}${request.id === initialRequestNo ? " is-focused" : ""}`}
      key={request.id}
    >
      <button
        type="button"
        className="manager-dossier-row procurement-queue-row"
        aria-haspopup="dialog"
        aria-label={`${request.id} ${request.title} karar dosyasını aç`}
        onClick={() => {
          setClosingRequestId(null);
          setExpandedRequestId(request.id);
          closeDecisionComposer();
        }}
      >
        <span className="manager-dossier-identity">
          <small className="manager-column-label">
            Ürün / Talep
          </small>
          <strong>{request.title}</strong>
          <span>Talep no: {request.id}</span>
        </span>
        <>
          <span className="manager-dossier-unit-price">
            <small className="manager-column-label">
              Birim fiyat
            </small>
            <strong>
              {evaluation && displayedOffer
                ? `${formatEvaluationAmount(
                  displayedOffer.unitPrice,
                  displayedOffer.currency ??
                  evaluation.comparisonCurrency,
                )} / ${displayedOffer.unit ?? request.unit ?? "birim"}`
                : "—"}
            </strong>
          </span>
          <span className="manager-dossier-quantity">
            <small className="manager-column-label">Miktar</small>
            <strong>
              {request.quantity !== undefined
                ? `${request.quantity.toLocaleString("tr-TR")} ${request.unit ?? "birim"}`
                : request.meta}
            </strong>
          </span>
          <span className="manager-dossier-proposal">
            <small className="manager-column-label">
              {selectionLabel}
            </small>
            <strong>
              {displayedOffer?.supplier ?? "Değerlendirme eksik"}
            </strong>
          </span>
          <span className="manager-dossier-request-date">
            <small className="manager-column-label">
              Talep tarihi
            </small>
            <strong>
              {request.createdAt
                ? formatDisplayDate(request.createdAt.slice(0, 10))
                : "Kayıtlı değil"}
            </strong>
            {request.createdAt &&
              formatDaysAgo(request.createdAt) ? (
              <span className="manager-request-age">
                {formatDaysAgo(request.createdAt)}
              </span>
            ) : null}
          </span>
        </>
        <span
          className={`manager-dossier-attention${requiresAttention ? " requires-attention" : ""}`}
          aria-label={`${attentionLabel}. ${attentionDetail}`}
          title={attentionDetail}
        >
          <small className="manager-column-label">
            Dosya durumu
          </small>
          <strong>{attentionLabel}</strong>
        </span>
        <span className="manager-dossier-open">
          <ProcurementQueueOpenIndicator />
        </span>
      </button>
      <ApprovalDossier context={context} />
    </article>
  );
}
